.text-input__container {
  display: flex;
  flex-flow: column nowrap;

  & input {
    line-height: 30px;
  }
}

.text-input__container .text-input__label {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;

  white-space: nowrap;
}

.text-input__container .text-input__description {
  color: #555768;

  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;

  white-space: pre-wrap;
}